import React, { useEffect } from "react";
import "./inventoryManagement.css";
import offer_management_img1 from "assets/inventory/offer_management1.png";
import offer_management_img2 from "assets/inventory/offer_management2.png";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";
import FaqBlock from "Component/FaqBlock/faqBlock";

const OfferManagement = () => {
  const questions = [
    "What role does CRM play in online real estate negotiations?",
    "How does CRM facilitate communication during online real estate negotiations?",
    "How does CRM help personalize online negotiations for clients?",
    "Can CRM help track and manage offers and counteroffers during online negotiations?",
  ];
  const answers = [
    "CRM helps manage and organize all negotiation activities in one place. It keeps track of conversations, documents, and agreements, making the process smoother and more efficient.",
    "CRM provides a centralized platform for all communications. It ensures that messages, emails, and calls are logged and easily accessible, helping everyone stay informed and updated.",
    "CRM stores detailed information about each client. This allows agents to tailor their negotiations based on the client's preferences, needs, and history, making the experience more personal and effective.",
    "Yes, CRM can track and manage all offers and counteroffers. It logs every detail and update, ensuring that all parties have access to the latest information and can respond promptly.",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Negotiation Offer Management | The Realtor Desk" description="" />
        <div className="sub-page--outer">
          <SubPageHeader
              title="Make Negotiations Simpler, Quicker, and Better"
              subTitle="Eliminate the hassles of negotiations and manage them more efficiently with Realtor Desk. Our CRM streamlines the negotiation process, enabling quicker decisions and smoother interactions, helping you close deals faster and with less effort."
          />
          <div className="container">
            <TextBlock
                shortTitle=""
                title="Online Real Estate Negotiations with Realtor Desk CRM"
                description="Negotiations can be time-consuming, complex, and often involve conflicts. Realtor Desk simplifies this process with its advanced online negotiations and offer management system. By eliminating complexities, it streamlines the negotiation process, improving efficiency and accelerating your sales cycle."
                textSize="large"
            />
            <ImageWithTextBlock
                shortTitle="Pre-Approved Schemes"
                title="Make Instant Offers with Pre-Approved Schemes"
                description="The Realtor Desk lets you create pre-defined schemes, payment plans, and cost structures, so your sales team can quickly select them with a click. This eliminates the need for manual calculations and prevents errors, thanks to the built-in cost and payments calculator. Additionally, internal approval logic ensures that sales members can offer discounts within set limits, with higher-level managers and sales heads approving larger discounts as per the hierarchy, streamlining the negotiation process."
                image={offer_management_img1}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Online Negotiations with Full Audit Trial"
                title="Streamline Negotiations with an Online System and Complete Audit Trial"
                description="The Realtor Desk simplifies the negotiation process by moving it online with a comprehensive audit trial. You can easily track the entire approval journey, from the initial request to each stage of approval or rejection, ensuring complete transparency and accountability throughout the process."
                image={offer_management_img2}
                imagePosition="left"
            />
            <FaqBlock
                questions={questions}
                answers={answers}
            />
          </div>
      </div>
    </>
  );
};

export default OfferManagement;
